import { useRequest, useRequestPagination } from './useRequest';

/**
 * POST 请求
 * @param url
 * @param body
 * @param config
 * @returns
 */
export const useRequestByPost = useRequest;

export const useRequestPaginationByPost = useRequestPagination;
